import { render, staticRenderFns } from "./FormDocumentos.vue?vue&type=template&id=0a4d0019"
import script from "./FormDocumentos.vue?vue&type=script&lang=js"
export * from "./FormDocumentos.vue?vue&type=script&lang=js"
import style0 from "./FormDocumentos.vue?vue&type=style&index=0&id=0a4d0019&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports